import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as PerformanceTrackerAction from './actions';
import { PerformanceTrackerService } from "./service";
import { IServerResponse } from "app/interface";

@Injectable()
export class PerformanceTrackerEffect {

    constructor(
        private action: Actions,
        private performanceTrackerService: PerformanceTrackerService
    ) { }

    GetPerformanceTrackerList = createEffect(() => this.action.pipe(
        ofType(type.GET_PERFORMANCE_TRACKER_LIST),
        switchMap(() => this.performanceTrackerService.getPerformanceTrackerList()),
        map((data: Array<any>) => new PerformanceTrackerAction.PerformanceTrackerList(data)
        )
    ));

    PerformanceTrackerById = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_PERFORMANCE_TRACKER_BY_ID),
        switchMap((data: any) => this.performanceTrackerService.getPerformanceTrackerById(data.payload)),
        map((data: Array<any>) => new PerformanceTrackerAction.PerformanceTrackerById(data)
        )
    ));

    SavePerformanceTracker = createEffect(() => this.action.pipe(
        ofType(type.SAVE_PERFORMANCE_TRACKER),
        switchMap((data: any) => data.payload.id
            ? this.performanceTrackerService.updatePerformanceTracker(data.payload)
            : this.performanceTrackerService.addPerformanceTracker(data.payload)),
        map((data: IServerResponse) => new PerformanceTrackerAction.SavePerformanceTrackerResp(data)
        )
    ));

    DeletePerformanceTracker = createEffect(() => this.action.pipe(
        ofType(type.DELETE_PERFORMANCE_TRACKER),
        switchMap((data: any) => this.performanceTrackerService.deletePerformanceTracker(data.payload)),
        map((data: IServerResponse) => new PerformanceTrackerAction.DeletePerformanceTrackerResp(data)
        )
    ));

    SearchPerformanceTrackerByFields = createEffect(() => this.action.pipe(
        ofType(type.SEARCH_PERFORMANCE_TRACKER_BY_FIELD),
        switchMap((data: any) => this.performanceTrackerService.searchPerformanceTrackerByFields(data.payload)),
        map((data) => new PerformanceTrackerAction.PerformanceTrackerByFieldList(data)
        )
    ));
}
